import './App.scss';

import Kontakt from './pages/Kontakt'
import Home from './pages/Home'
import Om from './pages/Om'
import CV from './pages/CV'
import Menu from './pages/Menu'
import NewsDetail from './pages/NewsDetail'
import ItemDetail from './pages/ItemDetail'
import Filter from './pages/Filter'

import ScrollToTop from './components/Atoms/ScrollToTop'

import React, { useState, Component } from 'react';
import {BrowserRouter as Router, Switch, Route, HashRouter} from 'react-router-dom'

import SimpleReactLightbox from 'simple-react-lightbox'





function App() {


  return (
    
      
    <div className="max-w-1200 margin-auto  bt br bl" >
      
      <SimpleReactLightbox>
          <HashRouter>
          <ScrollToTop />
            <Switch>
              {/* <Route path="/" exact component={Home} />
              <Route path="/kontakt" component={Kontakt} />
              <Route path="/cv" component={CV} />
              <Route path="/om" component={Om} />
              <Route path="/filter/nyheder" exact component={Filter} />
              <Route path="/nyheder/:id"  component={NewsDetail} />
              <Route path="/menu" exact component={Menu} />
              <Route path="/post/:id"  component={ItemDetail} />
              <Route path="/filter/kuratering" exact component={Filter} />
              <Route path="/filter/vaerker" exact component={Filter} /> */}
              <Route path="/" exact component={Home} />
              <Route path="/kontakt" component={Kontakt} />
              <Route path="/cv" component={CV} />
              <Route path="/om" component={Om} />
              <Route path="/nyheder/:id"  component={NewsDetail} />
              <Route path="/menu" exact component={Menu} />
              <Route path="/post/:id"  component={ItemDetail} />
              <Route path="/filter" component={Filter} />
              
              
              
            </Switch>
          </HashRouter>
        </SimpleReactLightbox> 
    </div>
    
    





  );
}

export default App;
